/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { SSR_DATA, DEFAULT_ENDPOINT } from '../configs/constants';
import { createUrlToJWT } from '../utils/urlToJWT';

export function createJwtTokenProvider(
  env: 'stg' | 'prd' = 'stg',
  hotelJWTHash: string,
  hotelXORKey: string,
) {
  const ssrDataUrl =
    env === 'stg'
      ? 'https://hotels.stg-apiairasia.com/hotelsa/getssrdata'
      : 'https://hotels.apiairasia.com/hotelsa/getssrdata';

  const tokenConvertor = createUrlToJWT(
    ssrDataUrl,
    hotelJWTHash,
    SSR_DATA,
    hotelXORKey,
  );

  const getToken = (endpoint?: string, forceRefresh?: boolean) => {
    const key = endpoint || DEFAULT_ENDPOINT;
    return tokenConvertor.getToken(key, forceRefresh);
  };

  return { getToken };
}
